module.exports = __webpack_public_path__ + "img/video-9.75f729d6.png";